import { User } from '@repo-level/core-front';

export const checkCompleteUserInformation = (
  user: User | undefined,
  isFR: boolean
) => {
  if (isFR) {
    return !!user?.firstName && !!user?.lastName && !!user?.dateOfBirth;
  }

  return (
    !!user?.firstName &&
    !!user?.lastName &&
    !!user?.dateOfBirth &&
    !!user?.mobilePhone &&
    !!user?.country &&
    !!user?.city &&
    !!user?.address &&
    !!user?.postalCode
  );
};
